import client from './client';

export const getCalendarData = async () => {
    try { 
        const response = await client.get("/api/calendars")
        return response
    } catch (error) {
        console.error('Error getting calendar data:', error);
        throw error;
    }
} 

export const saveCalendarData = async (body) => {
    try {
      const response = await client.post("/api/calendars", body)
      return response
    } catch (error) {
      console.error("Error al conectar con el servidor:", error);
      return error
    }
}

export const sendContactEmail = async (emailData) => {
  try {
      const response = await client.post("/api/email-send", { 
        data: emailData 
      });
      return response;
    } catch (error) {
      console.error("Error al enviar el correo:", error);
      return null; 
    }
};